import { Trans, useTranslation } from 'react-i18next'

import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export const CertificateModal = () => {
  const { t } = useTranslation()
  const { closeDialog } = useDialogBottomSheet()

  return (
    <Paper
      padding={[2]}
      className={s.box}
    >
      <p className={s.title}>{t('certificate.conditions')}</p>

      <div className={s.description}>
        <p>{t('certificate.use_variants')}</p>

        <ul className={s.ruleList}>
          <li>
            <Trans
              i18nKey="certificate.rule_less"
              components={{ u: <u /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="certificate.rule_more"
              components={{ u: <u /> }}
            />
          </li>
        </ul>
      </div>

      <Button
        className={s.button}
        onClick={closeDialog}
        borderRadius={'md'}
      >
        {t('okay')}
      </Button>
    </Paper>
  )
}
